import Box from "@/components/Box";
import RelatedTestsList from "@/components/reports/RelatedTestsList";
import Stack from "@/tpo/Stack";
import { useQuery } from "@apollo/client";

export default function RelatedTestsSection({
  query,
  variables,
  skip,
  getOrderUrl,
  getTestResultUrl
}) {
  const { data, loading } = useQuery(query, {
    variables,
    skip
  });

  const userTests = data?.userTests || [];
  const ordersInProgress = data?.ordersInProgress || [];
  const hasRelatedTests = userTests.length > 0 || ordersInProgress.length > 0;

  if (loading || !hasRelatedTests) {
    return null;
  }

  return (
    <Stack
      bg="white"
      borderRadius={20}
      px={[20, 20, 40]}
      pt={[40, 40, 60]}
      pb={[60, 60, 80]}
      maxWidth={1152}
      mx="auto"
      width="100%"
    >
      <Stack gap={16}>
        <Box fontFamily="gilroyBold" fontSize={[28, 28, 36]} lineHeight={["32px", "32px", "46px"]}>
          Related tests
        </Box>
        <Box
          fontFamily="gilroyMedium"
          fontSize={[14, 14, 16]}
          lineHeight={["24px", "24px", "28px"]}
        >
          The following tests all have markers that are considered in this report
        </Box>
      </Stack>
      <Box mt={40}>
        <RelatedTestsList
          ordersInProgress={ordersInProgress}
          userTests={userTests}
          getOrderUrl={getOrderUrl}
          getTestResultUrl={getTestResultUrl}
        />
      </Box>
    </Stack>
  );
}
